module.exports = __webpack_public_path__ + "static/media/avatar.e0763145.svg";